"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedSelectInput = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var react_select_1 = (0, tslib_1.__importStar)(require("react-select"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../../theme");
var flexbox_1 = require("../../flexbox");
var icon_button_1 = require("../../icon-button");
var icons_1 = require("../../icons");
var padding_1 = require("../../padding");
var text_link_1 = require("../../text-link");
var icons_2 = require("./icons");
function findOptionValue(options, isControlled, searchValue) {
    if (!searchValue)
        return undefined;
    var matched;
    options.forEach(function (option) {
        if ('value' in option) {
            if (option.value === searchValue) {
                matched = option;
            }
        }
        else if (!matched) {
            matched = findOptionValue(option.options, isControlled, searchValue);
        }
    });
    return matched || (isControlled ? null : undefined);
}
function formatGroupLabel(data) {
    var groupStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        textTransform: 'uppercase',
        fontSize: 10,
        fontWeight: 'bold',
    };
    var groupBadgeStyles = {
        display: 'none',
    };
    return (React.createElement("div", { style: groupStyles },
        data.icon && React.createElement("div", null, data.icon),
        React.createElement("span", null, data.label),
        React.createElement("span", { style: groupBadgeStyles }, data.options.length)));
}
function formatOptionLabel(data, context) {
    var optionContext = context.context;
    var descriptionStyles = {
        display: 'block',
        paddingTop: 2,
        fontSize: 12,
    };
    return (React.createElement(flexbox_1.Flexbox, { flexDirection: "row", alignItems: "center" },
        data.icon && React.createElement(padding_1.Padding, { right: 8 }, data.icon),
        React.createElement(flexbox_1.Flexbox, { flexDirection: "column" },
            React.createElement("span", null, data.label),
            data.description && optionContext === 'menu' && React.createElement("span", { style: descriptionStyles }, data.description))));
}
function AdvancedSelectInput(props) {
    var _a = props.defaultValue, defaultValue = _a === void 0 ? '' : _a, disabled = props.disabled, isClearable = props.isClearable, isInvalid = props.isInvalid, isLoading = props.isLoading, isMulti = props.isMulti, _b = props.menuPlacement, menuPlacement = _b === void 0 ? 'auto' : _b, _c = props.menuPortalTarget, menuPortalTarget = _c === void 0 ? document.body : _c, name = props.name, customFilter = props.customFilter, onBlur = props.onBlur, onChange = props.onChange, onInputChange = props.onInputChange, _d = props.options, options = _d === void 0 ? [] : _d, value = props.value, placeholder = props.placeholder, _e = props.icon, icon = _e === void 0 ? 'select' : _e, id = props.id, testId = props.testId, inputId = props.inputId;
    var isControlled = 'value' in props;
    var defaultOption = findOptionValue(options, isControlled, defaultValue);
    var optionValue = value && Array.isArray(value)
        ? value.map(function (val) { return findOptionValue(options, isControlled, val); }).filter(function (val) { return !!val; })
        : findOptionValue(options, isControlled, value);
    var _f = React.useState(false), isFocused = _f[0], setFocused = _f[1];
    function handleChange(option) {
        if (!option) {
            onChange('');
            return;
        }
        if (Array.isArray(option)) {
            onChange(option.map(function (o) { return o.value; }));
        }
        else {
            onChange(option.value);
        }
    }
    var selectStyles = {
        dropdownIndicator: function () { return ({
            visibility: 'hidden',
        }); },
        loadingIndicator: function (styles) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, styles), { paddingRight: 16 })); },
        clearIndicator: function () { return ({
            display: 'flex',
            alignItems: 'center',
            marginRight: 16,
            ':hover': {
                color: theme_1.colors.primary,
                cursor: 'pointer',
                background: theme_1.colors.gray_xxl,
                borderRadius: 3,
            },
        }); },
        container: function (styles) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, styles), { fontFamily: theme_1.fontFamilies.body, fontSize: theme_1.fontSizes.regular.fontSize })); },
        control: function (_styles, state) {
            var focusStyles = state.isFocused || state.isSelected
                ? {
                    border: "1px solid ".concat(theme_1.colors.primary),
                    boxShadow: "0 0 0 3px ".concat(theme_1.colors.primary_l, "30"),
                }
                : {
                    border: '1px solid #dbdbdb',
                };
            var invalidStyles = isInvalid
                ? {
                    borderColor: theme_1.colors.red,
                    boxShadow: '0 0 0 3px rgba(189, 73, 50, 0.25)',
                }
                : {};
            return (0, tslib_1.__assign)((0, tslib_1.__assign)((0, tslib_1.__assign)({}, focusStyles), invalidStyles), { lineHeight: '21px', color: theme_1.colors.gray_d, minHeight: '40px', boxSizing: 'border-box', width: '100%', borderRadius: '3px', background: 'white', appearance: 'none', display: 'flex', alignItems: 'center' });
        },
        option: function (_provided, state) {
            var focused = state.isFocused
                ? {
                    background: theme_1.colors.primary,
                    color: 'white',
                }
                : {};
            var optionDisabled = state.data.isDisabled
                ? {
                    color: theme_1.colors.gray_l,
                    cursor: 'default',
                    ':hover': {
                        background: 'none',
                    },
                }
                : {};
            return (0, tslib_1.__assign)((0, tslib_1.__assign)({ fontSize: theme_1.fontSizes.regular.fontSize, fontFamily: theme_1.fontFamilies.body, padding: '8px 12px', cursor: 'pointer', color: theme_1.colors.gray_d, background: state.isSelected ? theme_1.colors.gray_xxl : 'white', ':hover': {
                    background: theme_1.colors.primary,
                    color: 'white',
                } }, focused), optionDisabled);
        },
        placeholder: function (styles) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, styles), { color: theme_1.colors.text_placeholder, lineHeight: '21px' })); },
        menu: function (styles) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, styles), { zIndex: theme_1.zIndices.select })); },
        menuPortal: function (styles) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, styles), { zIndex: theme_1.zIndices.select })); },
        multiValue: function () { return ({
            display: 'flex',
            alignItems: 'center',
            padding: 0,
            fontSize: 12,
            background: theme_1.colors.primary_xxl,
            boxShadow: "0 0 0 1px inset ".concat(theme_1.colors.primary_xl),
            borderRadius: 2,
            height: 24,
            marginRight: 4,
        }); },
        multiValueLabel: function () { return ({
            color: theme_1.colors.primary,
            padding: '0 0 0 8px',
        }); },
        multiValueRemove: function () { return ({
            color: theme_1.colors.primary,
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 24,
            width: 24,
            boxShadow: "1px 0 inset ".concat(theme_1.colors.primary_xl),
            borderTopRightRadius: 2,
            borderBottomRightRadius: 2,
            marginLeft: 8,
            cursor: 'pointer',
            ':hover': {
                background: theme_1.colors.primary,
                color: 'white',
            },
        }); },
        noOptionsMessage: function (styles) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, styles), { fontFamily: theme_1.fontFamilies.body, fontSize: theme_1.fontSizes.regular.fontSize })); },
        loadingMessage: function (styles) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, styles), { fontFamily: theme_1.fontFamilies.body, fontSize: theme_1.fontSizes.regular.fontSize })); },
    };
    return (React.createElement(StyledDiv, { onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); } },
        React.createElement(react_select_1.default, { inputId: inputId, "data-testid": testId, defaultValue: defaultOption, classNamePrefix: "react-select", filterOption: customFilter, formatGroupLabel: formatGroupLabel, formatOptionLabel: formatOptionLabel, isClearable: isClearable, isDisabled: disabled, isLoading: isLoading, isMulti: isMulti, menuPortalTarget: menuPortalTarget, menuPlacement: menuPlacement, captureMenuScroll: true, name: "advanced-select-".concat(name), options: options, styles: selectStyles, onBlur: onBlur, onChange: handleChange, onInputChange: onInputChange, placeholder: placeholder, value: optionValue !== null && optionValue !== void 0 ? optionValue : null, components: {
                ClearIndicator: function (_a) {
                    var clearValue = _a.clearValue;
                    return (React.createElement(StyledIconButtonWrapper, { onMouseOver: function () {
                            if (!isFocused)
                                setFocused(true);
                        } },
                        React.createElement(icon_button_1.IconButton, { type: "close", onClick: clearValue })));
                },
                IndicatorsContainer: IndicatorsContainer,
                DropdownIndicator: function () { return (React.createElement(StyledIcon, { isFocused: isFocused }, icon === 'select' ? React.createElement(icons_2.IconSelect, { testId: "asi-icon-select" }) : React.createElement(icons_1.IconSearch, { testId: "asi-icon-search" }))); },
            } }),
        React.createElement("input", { type: "hidden", name: name, id: id, value: value || '' })));
}
exports.AdvancedSelectInput = AdvancedSelectInput;
function IndicatorsContainer(props) {
    var hasValue = props.hasValue, selectProps = props.selectProps, isMulti = props.isMulti, options = props.options, setValue = props.setValue;
    function handleSelectAll() {
        var optionsToSelect = options
            .flatMap(function (option) {
            if (isGroupedOption(option)) {
                return option.options.filter(function (o) { return !o.isDisabled; });
            }
            return option.isDisabled ? null : option;
        })
            .filter(Boolean);
        setValue(optionsToSelect, 'set-value');
    }
    return (React.createElement(flexbox_1.Flexbox, { alignItems: "center", gap: 8 },
        isMulti && !hasValue && selectProps.menuIsOpen && (React.createElement("div", { "aria-hidden": "true", onMouseDown: function (e) {
                e.preventDefault();
                e.stopPropagation();
            } },
            React.createElement(text_link_1.TextLink, { underline: false, underlineOnHover: true, onClick: function () {
                    handleSelectAll();
                } }, "Select all"))),
        React.createElement(react_select_1.components.IndicatorsContainer, (0, tslib_1.__assign)({}, props))));
}
function isGroupedOption(option) {
    return 'options' in option;
}
var StyledIconButtonWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
var StyledDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  position: relative;\n\n  :global(.react-select__control) {\n    position: relative;\n    z-index: 1;\n  }\n  :global(.react-select__menu) {\n    position: absolute;\n    z-index: 2;\n  }\n  :global(.react-select__single-value) {\n    max-width: calc(100% - 80px);\n  }\n"], ["\n  position: relative;\n\n  :global(.react-select__control) {\n    position: relative;\n    z-index: 1;\n  }\n  :global(.react-select__menu) {\n    position: absolute;\n    z-index: 2;\n  }\n  :global(.react-select__single-value) {\n    max-width: calc(100% - 80px);\n  }\n"])));
var StyledIcon = styled_components_1.default.div(templateObject_3 || (templateObject_3 = (0, tslib_1.__makeTemplateObject)(["\n  color: ", ";\n  padding-left: 10px;\n  padding-right: 10px;\n  pointer-events: none;\n  z-index: 1;\n"], ["\n  color: ", ";\n  padding-left: 10px;\n  padding-right: 10px;\n  pointer-events: none;\n  z-index: 1;\n"])), function (_a) {
    var isFocused = _a.isFocused;
    return (isFocused ? theme_1.colors.primary : theme_1.colors.gray);
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=advanced-select-input.js.map